// global.config.js

// Фабрика для создания конфигурации
export async function getConfig() {
  return {
    env: {
      isMobileApp: process.env.MOBILE_APP || false,
    },

    core: {
      websocket: true,
    },

    app: {
      // Канонический origin страниц: отсюда App.vue строит canonical, og:url и alternate.
      // Именно литерал, а не process.env — в клиентский бандл переменные не инлайнятся.
      url: 'https://communephuket.com',

      messages: {
        en: {
          meta: {
            title: "Commune – Beachfront Dining & Nightlife in Phuket",
            description: "Experience Phuket's premier beachfront destination on Karon Beach. Quality dining, sunset cocktails, and vibrant nightlife from sunrise to moonlight.",
            keywords: "Beach Club, Restaurant, Bar, Nightlife, Phuket, Karon Beach, Cocktails, Dining, Sunset, DJ, Live Music, Pool, Ocean View",
            og: {
              title: "Commune – Beachfront Dining & Nightlife in Phuket",
              description: "Experience Phuket's premier beachfront destination on Karon Beach. Quality dining, sunset cocktails, and vibrant nightlife from sunrise to moonlight.",
              image: "/favicon/cover.jpg"
            },
            twitter: {
              title: "Commune – Beachfront Dining & Nightlife in Phuket",
              description: "Experience Phuket's premier beachfront destination on Karon Beach. Quality dining, sunset cocktails, and vibrant nightlife from sunrise to moonlight.",
              image: "/favicon/cover.jpg",
              card: "summary_large_image"
            },
            htmlAttrs: {
              lang: "en",
              "data-theme": "light"
            }
          },
        }
      },
    },

    // ISO-код, не символ: martyrs берёт символ и формат из своей таблицы валют
    // (models/currencies.js). Неизвестное значение («฿») ядро заменяет на USD.
    currency: 'THB',
    modules: {
      currency: 'THB',
      // backoffice — первым: moduleManager.registerAll объявляет маршруты модулей
      // в порядке этого объекта, а auth, products и organizations вешают свои
      // разделы на маршрут 'Backoffice Root'. Объявленные раньше родителя
      // маршруты терялись, и /backoffice/products отдавал 404.
      backoffice: {
        loader: () => import(
          /* webpackChunkName: "module-backoffice" */
          '@ozdao/martyrs/modules/backoffice/client'
        ),
        routes: ['/backoffice', '/admin'],
        priority: 'normal',
        dependencies: []
      },
      auth: {
        authMethodsExclude: ['phone'],
        loader: () => import('@ozdao/martyrs/modules/auth/client'),
        routes: ['/', '/backoffice/auth', '/backoffice/users'],
        contexts: ['backoffice'],
        priority: 'high',
        dependencies: ['backoffice']
      },
      products: {
        loader: () => import(
          /* webpackChunkName: "module-products" */
          '@ozdao/martyrs/modules/products/client'
        ),
        routes: [
          '/backoffice/products',
          '/backoffice/categories'
        ],
        contexts: ['backoffice'],
        priority: 'normal',
        dependencies: ['organizations']
      },
      organizations: {
        loader: () => import(
          /* webpackChunkName: "module-organizations" */
          '@ozdao/martyrs/modules/organizations/client'
        ),
        routes: [
          '/backoffice/organizations'
        ],
        contexts: ['backoffice'],
        preload: true,
        priority: 'normal',
        dependencies: ['backoffice']
      },
      orders: {
        allowUnauthenticatedOrders: true,
        loader: () => import(
          /* webpackChunkName: "module-orders" */
          '@ozdao/martyrs/modules/orders/client'
        ),
        routes: [
          '/backoffice/orders',
          '/backoffice/customers',
          '/backoffice/applications'
        ],
        contexts: ['backoffice'],
        priority: 'normal',
        dependencies: ['products', 'backoffice'],
        statuses: [
          {
            value: 'created',
            label: 'Pending',
            description: 'Your request has been received and is awaiting review.'
          },
          {
            value: 'confirmed',
            label: 'Confirmed',
            description: 'Your request has been confirmed. We will reach out with further details shortly.'
          },
          {
            value: 'in_progress',
            label: 'In Progress',
            description: 'Your request is currently being processed.'
          },
          {
            value: 'finished',
            label: 'Completed',
            description: 'Your request has been fulfilled. Thank you for choosing Commune.'
          },
          {
            value: 'cancelled',
            label: 'Cancelled',
            description: 'This request has been cancelled.'
          }
        ],
        showFees: true,
        feesRate: 0,
        showVat: false,
        vatRate: 0,
        showDeliveryFee: true,
        deliveryRate: 1,
        delivery_formula: {
          pickupCost: 0,
          mailCost: 300,
          courierBase: 50,
          courierPerKm: 15,
          courierDiscountFactor: 7.5
        }
      },
      rents: {
        loader: () => import(
          /* webpackChunkName: "module-rents" */
          '@ozdao/martyrs/modules/rents/client'
        ),
        routes: [
          '/backoffice/rents'
        ],
        contexts: ['backoffice'],
        priority: 'normal',
        dependencies: ['organizations', 'backoffice']
      },
      inventory: {
        loader: () => import(
          /* webpackChunkName: "module-inventory" */
          '@ozdao/martyrs/modules/inventory/client'
        ),
        routes: [
          '/backoffice/inventory'
        ],
        contexts: ['backoffice'],
        priority: 'normal',
        dependencies: ['products', 'backoffice']
      },
      spots: {
        loader: () => import(
          /* webpackChunkName: "module-spots" */
          '@ozdao/martyrs/modules/spots/client'
        ),
        routes: [
          '/backoffice/spots'
        ],
        contexts: ['backoffice'],
        priority: 'normal',
        dependencies: ['organizations', 'backoffice']
      },
      reviews: {
        loader: () => import(
          /* webpackChunkName: "module-reviews" */
          '@/modules/reviews/reviews.client.js'
        ),
        routes: ['/backoffice/reviews'],
        contexts: ['backoffice'],
        priority: 'normal',
        dependencies: ['backoffice']
      },
      notifications: {
        loader: () => import(
          /* webpackChunkName: "module-notifications" */
          '@ozdao/martyrs/modules/notifications/client'
        ),
        routes: ['/notifications', '/alerts', '/backoffice/notifications'],
        contexts: ['backoffice'],
        priority: 'high',
        preload: true,
        dependencies: ['backoffice']
      },
    },
  };
}
